import gql from "graphql-tag";

export const GET_POST_BY_ID = gql`
query posts_by_pk($id: uuid!) {
    posts_by_pk(id: $id) {
      id
      content
      parse_body
      type
      status
      publish_time
      image_path
      image_url
      post_image_galleries {
        id
        image_path
        image_url
      }
      post_likes_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;